// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getDatabase } from "firebase/database"
import { getStorage } from "firebase/storage"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAZo8K_sgg00S_zg4lbiVNc4D2dk2o8ilA",
  authDomain: "channect-overflow.firebaseapp.com",
  projectId: "channect-overflow",
  storageBucket: "channect-overflow.appspot.com",
  messagingSenderId: "925426885477",
  appId: "1:925426885477:web:1abf8873c456686206778c",
  measurementId: "G-TXE6SG9D03"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const rtdb = getDatabase();
export const storage = getStorage(app);